import React, { Component } from 'react';
import './Payment.css';

import paypal from '../../../assets/images/paypal-logo.png';

class Payment extends Component {

  render() {
    return (
      <div className='row payment-container'>
        <div className="container-lg">
          <h2>
            Pagá
            <span className="paypal-logo">
              <img src={paypal} alt="Usaproductos" title="Usaproductos" />
            </span>
          </h2>
          <div className="text">
            <p>Ya te cotizamos el servicio, <br/> ahora pagalo fácil, rápido y seguro con tu tarjeta de crédito.</p>
            <div className="btn-container">
            <form name="form_paypal" id="form_paypal" action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
              <div className="cont_form">
                <input type="hidden" name="cmd" value="_xclick" />
                <input type="hidden" name="business" value="jlw.cars@gmail.com" />
                <input type="hidden" name="item_name" value="" />
                <input type="hidden" name="buyer_credit_promo_code" value="" />
                <input type="hidden" name="buyer_credit_product_category" value="" />
                <input type="hidden" name="buyer_credit_shipping_method" value="" />
                <input type="hidden" name="buyer_credit_user_address_change" value="" />
                <input type="hidden" name="return" value="" />
                <input type="hidden" name="no_shipping" value="0" />
                <input type="hidden" name="no_note" value="1" />
                <input type="hidden" name="currency_code" value="USD" />
                <input type="hidden" name="lc" value="" />
                <input type="hidden" name="bn" value="PP-BuyNowBF" />
                <input type="submit" className="btn paypalbutton" value="Pagar con Paypal" />
              </div>
            </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Payment;



// WEBPACK FOOTER //
// ./src/components/Home/Payment/Payment.js